import React from 'react';

import { ListingCard, NamedLink  } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './SellerListings.module.css';

const SellerListings = props => {
  const {
    listings,
    sellerName,
    currentUser,
    onToggleFavorite,
    onRequireLogin,
    sellerId
  } = props;

  if (!listings || listings.length === 0) {
    return null;
  }

  return (
    <section className={css.root}>
      <div className={css.heading}>
        <h2 className={css.headingTitle}>
          <FormattedMessage
            id="SellerListings.moreFrom"
            values={{ sellerName: sellerName?.toUpperCase() }}
          />
        </h2>

        {sellerId ? (
        <NamedLink
            name="ProfilePage"
            params={{ id: sellerId }}
            className={css.viewAll}
        >
            <FormattedMessage id="SellerListings.viewAll" /> →
        </NamedLink>
        ) : null}
      </div>

      <div className={css.grid}>
        {listings.map(listing => (
          <ListingCard
            key={listing.id.uuid}
            listing={listing}
            renderSizes="(max-width: 767px) 50vw, 25vw"
            showAuthorInfo={false}
            currentUser={currentUser}
            onToggleFavorite={onToggleFavorite}
            onRequireLogin={onRequireLogin}
            favoriteOnInfo
          />
        ))}
      </div>
    </section>
  );
};

export default SellerListings;